import { F32 } from '../engine/typed-arrays.js';

function setExtentCorners(corners, min, max) {
  for (let i = 0; i < 8; i++) {
    corners[i * 3] = i & 1 ? max[0] : min[0];
    corners[i * 3 + 1] = i & 2 ? max[1] : min[1];
    corners[i * 3 + 2] = i & 4 ? max[2] : min[2];
  }
}
function extentCorners(min, max) {
  const c = new F32(24);
  setExtentCorners(c, min, max);
  return c;
}
function buildSkinnedBoneCorners(mesh) {
  const positions = mesh._cpuPositions;
  const skeleton = mesh.skeleton;
  if (!positions || positions.length === 0 || !skeleton || !skeleton.weights) {
    return null;
  }
  const vertexCount = positions.length / 3 | 0;
  const boneCount = skeleton.boneCount;
  const boneMin = new F32(boneCount * 3).fill(Number.POSITIVE_INFINITY);
  const boneMax = new F32(boneCount * 3).fill(Number.NEGATIVE_INFINITY);
  const boneUsed = new Uint8Array(boneCount);
  const accumulate = (joints, weights, vertex) => {
    const base = vertex * 4;
    for (let k = 0; k < 4; k++) {
      if (weights[base + k] > 0) {
        const bone = joints[base + k];
        if (bone < boneCount) {
          const bo = bone * 3;
          const vo = vertex * 3;
          if (positions[vo] < boneMin[bo]) {
            boneMin[bo] = positions[vo];
          }
          if (positions[vo + 1] < boneMin[bo + 1]) {
            boneMin[bo + 1] = positions[vo + 1];
          }
          if (positions[vo + 2] < boneMin[bo + 2]) {
            boneMin[bo + 2] = positions[vo + 2];
          }
          if (positions[vo] > boneMax[bo]) {
            boneMax[bo] = positions[vo];
          }
          if (positions[vo + 1] > boneMax[bo + 1]) {
            boneMax[bo + 1] = positions[vo + 1];
          }
          if (positions[vo + 2] > boneMax[bo + 2]) {
            boneMax[bo + 2] = positions[vo + 2];
          }
          boneUsed[bone] = 1;
        }
      }
    }
  };
  const joints0 = skeleton.joints;
  const weights0 = skeleton.weights;
  const joints1 = skeleton.joints1;
  const weights1 = skeleton.weights1;
  for (let v = 0; v < vertexCount; v++) {
    accumulate(joints0, weights0, v);
    if (joints1 && weights1) {
      accumulate(joints1, weights1, v);
    }
  }
  const bones = [];
  for (let b = 0; b < boneCount; b++) {
    if (boneUsed[b]) {
      const o = b * 3;
      bones.push({
        boneIndex: b,
        corners: extentCorners([boneMin[o], boneMin[o + 1], boneMin[o + 2]], [boneMax[o], boneMax[o + 1], boneMax[o + 2]])
      });
    }
  }
  return bones;
}
function growCornersByMatrix(corners, matrix, min, max, offset = 0) {
  const m0 = matrix[offset], m1 = matrix[offset + 1], m2 = matrix[offset + 2], m4 = matrix[offset + 4], m5 = matrix[offset + 5], m6 = matrix[offset + 6], m8 = matrix[offset + 8], m9 = matrix[offset + 9], m10 = matrix[offset + 10], m12 = matrix[offset + 12], m13 = matrix[offset + 13], m14 = matrix[offset + 14];
  for (let i = 0; i < 8; i++) {
    const lx = corners[i * 3];
    const ly = corners[i * 3 + 1];
    const lz = corners[i * 3 + 2];
    const x = m0 * lx + m4 * ly + m8 * lz + m12;
    const y = m1 * lx + m5 * ly + m9 * lz + m13;
    const z = m2 * lx + m6 * ly + m10 * lz + m14;
    if (x < min[0]) {
      min[0] = x;
    }
    if (y < min[1]) {
      min[1] = y;
    }
    if (z < min[2]) {
      min[2] = z;
    }
    if (x > max[0]) {
      max[0] = x;
    }
    if (y > max[1]) {
      max[1] = y;
    }
    if (z > max[2]) {
      max[2] = z;
    }
  }
}

export { buildSkinnedBoneCorners, extentCorners, growCornersByMatrix, setExtentCorners };
//# sourceMappingURL=aabb-corners.js.map
